import { ModuleState } from '@gongxigames/framework/slot/fragments/module/ModuleState';
import { GlobalEventsMapForBackwardCompatibility } from '@gongxigames/framework/slot/events';
import { Action } from 'com/gongxigames/math/core/game/enums/Action';
import { MultiSetsPromotionModule, MultiSetsPromotionStates } from '@gongxigames/framework/promotions';

export class MultiSetsPromotionInitState extends ModuleState<null, MultiSetsPromotionModule, GlobalEventsMapForBackwardCompatibility> {
    protected setupEvents(): void {
        this.setEventHandler('General.Game.STARTED', this.onGameStarted.bind(this));
    }

    private onGameStarted(): void {
        const promotion = this.module.getPromotion();

        if (promotion.hasPromotion()) {
            this.module.gotoState(this.isRestore ? MultiSetsPromotionStates.RESTORE : MultiSetsPromotionStates.START);
        } else {
            this.module.gotoState(MultiSetsPromotionStates.BASIC);
        }
    }

    private get isRestore(): boolean {
        return this.module.logic.nextAction !== Action.SPIN;
    }

    public onEnterState(): void {}
    public onLeaveState(): void {}
}
